<template>
  <a-modal
    :open="open"
    class="portfolios"
    title="Campañas asociadas"
    width="400px"
    centered
    @cancel="handleClose"
    :footer="null"
  >
    <CustomScrollbar height="calc(100vh - 300px)" auto>
      <span class="type">
        {{
          Number(template?.template_type) === TemplateType.Default
            ? `Creado desde ${ProductName}`
            : "Plantilla HTML"
        }}
      </span>
      <h2 class="name">{{ template?.name }}</h2>
      <span class="description">Hay <span class="count">{{ countPortfolios }} campañas</span> asociadas a esta plantilla:</span>
      <ul class="portfolios__list">
        <li v-for="item in template?.portfolios">
          {{ item.name }}
        </li>
      </ul>
    </CustomScrollbar>
    <a-divider />
    <div class="footer">
      <a-button type="primary" ghost block @click="handleEditPortfolio">
        <EditOutlined /> Editar campañas
      </a-button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ProductName } from "@/app/shared/utils/constants";
import { Template, TemplateType } from "@/@types/flows/emailTemplates";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { EditOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  template: Template | undefined;
  open: boolean;
}>();

const emit = defineEmits<{ "update:open": [open: boolean]; update: [] }>();

const router = useRouter();

const handleClose = () => emit("update:open", false);

const countPortfolios = computed(() => {
  return props.template?.portfolios?.length;
});

const handleEditPortfolio = () => {
  router.push(`/flows/templates-email/${props.template?.id}?tab=general`);
};
</script>

<style scoped lang="sass">
.type
  font-size: 12px
  color: $text-secondary
  line-height: 20px
.name
  font-weight: 600
  font-size: 16px
  color: $gray-9
  margin-bottom: 2px
.description
  font-weight: 400
  font-size: 14px
  color: $gray-8
  .count
    color: $primary
    font-weight: 500
.portfolios
  &__list
    padding-inline-start: 25px
    color: $gray-9
    li
      margin-top: 10px
.footer
  display: flex
  align-items: center
  justify-content: flex-end
  padding: 15px 20px
  border-top: $border-normal
  position: absolute
  width: 100%
  bottom: 0
  left: 0

</style>
